<template>
  <div class="get-directions">
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-5">
          <img
            class="img-responsive"
            src="../../static/images/get-directions-arrow.png"
            alt="arrow"
          />
          <span class="text-center">Get Directions</span>
        </div>
        <div class="col-md-8 .col-sm-7">
          <form action="" method="get" target="_blank">
            <!-- <input type="hidden" name="daddr" value="" /> -->
            <div class="input-group input-group-lg">
              <input
                class="search-area form-control"
                type="text"
                name="saddr"
                placeholder="Enter Your Starting Address"
              />
              <span class="input-group-btn">
                <button
                  class="btn btn-default zip-directions-submit btn-search"
                >
                  <i class="fa fa-search"></i>
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.get-directions {
  background: #ddd;
  padding: 30px 0;
}

.get-directions img {
  max-height: 50px;
  display: inline-block;
  margin-top: -15px;
}

.get-directions .col-sm-5 span {
  font-size: 32px;
  display: inline-block;
  padding: 0;
  margin: 0 0 0 15px;
  font-weight: 300;
}

.get-directions .btn-search {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.get-directions .input-group {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.get-directions .search-area {
  width: 100%;
}

@media (min-width: 768px) {
  .get-directions .col-sm-5 {
    text-align: right;
  }
}

@media (max-width: 767px) {
  .get-directions .col-sm-5 {
    text-align: center;
    margin-bottom: 15px;
  }
}
</style>
